import Snap from "snapsvg";

const $ = require("jquery");

const laptop = {
  CHAR_FADEIN_DELAY: 300,
  textAttrs: {
    fill: "#FFF",
    "font-size": "200%",
    opacity: "0.75",
  },

  fadeIn(el) {
    Snap.animate(
      0,
      1,
      (value) => {
        el.attr({
          opacity: value,
        });
      },
      100
    );
  },

  /**
   * Adds a hidden text group, with each character split into separate tspans.
   *
   * @param {string} text - use this string for text items.
   * @param {number} x - x coords
   * @param {number} y - y coords
   *
   * @return {array}
   */
  addTextGroup(text, x, y) {
    const group = this.s.g().attr(this.textAttrs);
    return group.text(x, y, text.split("")).selectAll("tspan").attr({
      opacity: 0,
    });
  },

  /**
   * Add animated text to svg el.
   */
  animateSvg() {
    this.s = Snap(".laptop__screen svg");

    const self = this;
    const designGroupEls = this.addTextGroup("DESIGN", 145, 210);
    const codeGroupEls = this.addTextGroup("CODE", 445, 255);

    designGroupEls.forEach((el, index) => {
      setTimeout(() => {
        self.fadeIn(el);
      }, index * self.CHAR_FADEIN_DELAY);
    });

    setTimeout(() => {
      codeGroupEls.forEach((el, index) => {
        setTimeout(() => {
          self.fadeIn(el);
        }, index * self.CHAR_FADEIN_DELAY);
      });
    }, designGroupEls.length * self.CHAR_FADEIN_DELAY);
  },

  /**
   * If we've got a laptop el, start the animation.
   */
  init() {
    this.$wrapper = $(".laptop__screen");
    if ($("body").hasClass("body--home") && this.$wrapper.length) {
      this.animateSvg();
    }
  },
};

export default laptop;
